class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  onMouseLeave() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    // Don't close the menu if keyboard focus is still inside it.
    if (this.contains(document.activeElement)) return;

    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }

  onSummaryClick(event) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    // Parts & Accessories remains dropdown-only.
    if (this.mainDetailsToggle.dataset.clickableParent !== 'true') return;

    event.preventDefault();

    window.location.href = this.mainDetailsToggle.dataset.menuUrl;
  }

  onToggle() {
    if (!this.header) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
